import React, { useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog, IconButton,
    Paper, Radio, TextField, FormControlLabel, RadioGroup, Box, Grid,
    Button, MenuItem, FormControl, InputLabel, Select,
    Checkbox,
    Typography,
    Tooltip,
    Autocomplete,
    Snackbar
} from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios'
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SaveIcon from '@mui/icons-material/Save';
import { BootstrapDialog, BootstrapDialogTitle } from '../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../reusableComponent/ErpTextField';
import { addCustomerSupplierAdvancePayment, editDeleteCustomerSupplierAdvancePayment, getBankList, getCNSList } from '../../actions/actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dateConversionOnEntryPage } from '../reusableComponent/dateConversionOnEntryPage';
import styles from '../../styles.module.css';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { makeStyles } from '@mui/styles';
import { financialYear } from '../reusableComponent/financialYear';
import Breadcrumb from '../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../reusableComponent/BackBtn';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});

function Customer_Supplier_AdvancePaymentAdd() {
    const urlLocation = useLocation();
    const prName = urlLocation.state === null ? undefined : urlLocation.state.prName;
    const editInfo = urlLocation.state.row;
    const backBtnLen = urlLocation.state.backBtn;
    const classes = useStyles();
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const location = useLocation();
    const editData = editInfo && editInfo;
    const editid = editData && editData.cns_advPay_id;
    const [successMessage, setSuccessMessage] = useState(null);
    const [open, setOpen] = React.useState(false);
    const [openSnak, setOpenSnak] = React.useState(false);
    const [CNS_id, setCNS_id] = useState(editData ? editData.CNS_id : prName ? prName : null);
    const [bank_id, setBank] = useState(editData ? editData.bank_id : null);

    const [data, setData] = useState({
        amount: editData ? editData.amount : 0,
        paymentMode: editData ? editData.paymentMode : '',
        remark: editData ? editData.remark : '',
        instrumentNo: editData ? editData.instrumentNo : '',
    });

    const CNS_list = useSelector(state => state.CNS.CNS)
    const bankList = useSelector(state => state.bank.bank)

    const handleChangeBank = (event, newValue) => {
        setBank(newValue)
    }

    const handleChangeCNS = (event, newValue) => {
        setCNS_id(newValue)
    }
    const [advanceDate, setAdvanceDate] = React.useState(dayjs(new Date()));
    const handleChangeAdvancDate = (newValue) => {
        setAdvanceDate(newValue);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    useEffect(() => {
        dispatch(getBankList({ companyId: userInfo.companyId }))
        dispatch(getCNSList({financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: location.pathname == '/sales/add-advance-customer-payment' ? 'Customer' : 'Supplier' }))
        if (editData) {
            setCNS_id({
                CNS_Name: editData.CNS_Name,
                CSNId: editData.CNS_id,
                emailId: editData.emailId,
                gstn: editData.gstn,
                address: editData.address,
                pinCode: editData.pinCode,
                state: editData.state,
            })
            setBank({
                bankName: editData.bankName,
                branchCode: editData.branchCode,
                id: editData.bank_id,
            })
        }
    }, []);

    const onSubmit = (event) => {
        const sending_data = {
            companyId: userInfo.companyId,
            id: editid,
            ...data,
            CNS_Type: CNS_id.CNS_Type,
            CNS_id: CNS_id.CSNId,
            bank_id: data.paymentMode == 'Cash' ? null : bank_id.id,
            advanceDate: dateConversionOnEntryPage(advanceDate),
            finYear: editData ? editData.finYear : financialYear(userInfo.financialYear, advanceDate.$M, advanceDate.$y),
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteCustomerSupplierAdvancePayment(sending_data));
        } else {
            dispatch(addCustomerSupplierAdvancePayment(sending_data));
        }
    }

    var containsSales = location.pathname.includes('/sales/');

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.customer_supplier_advancePayment.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setShouldShowMsg(true);
                // navigate(-1, { responseMessage });
                navigate(containsSales == true ? '/sales/customer-payment' : '/purchase/supplier-payment' , { state: { backBtnTab: backBtnLen, responseMessage } });

            }
        }
    }, [shouldShowMsg, responseMessage, backBtnLen]);


    return (
        <>
            <div>
            <Breadcrumb
                        routeSegments={[
                            { name: location.pathname == '/sales/add-advance-customer-payment' ? 'Sales' : 'Purchase', path: location.pathname == '/sales/add-advance-customer-payment' ? '/sales/' : '/purchase/' },
                            { name: location.pathname == '/sales/add-advance-customer-payment' ? 'Customer Advance Payment' : 'Supplier Advance Payment', path: location.pathname == '/sales/add-advance-customer-payment' ? '/sales/customer-payment' : '/purchase/supplier-payment' },
                            { name: location.pathname == '/sales/add-advance-customer-payment' ? 'Create Customer Advance Payment' : 'Create Supplier Advance Payment'}
                        ]}
                    />
            <Paper className={`${styles.list_container}`} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
               
                {/* <Box >
                    <Grid container spacing={0.2} sx={{ pb: 1 }}>
                        <Grid item md={12} xs={12}>
                            <Typography className={`${styles.page_title}`}>Create {location.pathname == '/sales/add-advance-customer-payment' ? 'Customer' : 'Supplier'} Advance Payment</Typography>
                        </Grid>
                    </Grid>
                </Box> */}
                 <Box sx={{ m: 2}} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1} sx={{ p: 1 }}>
                            {editData ?
                                <>
                                    <Grid item xs={2} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Reference No</Typography>
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_input}`}>
                                        <ERPinput
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                            size='small'
                                            fullWidth
                                            name="advPaymentReferenceNo"
                                            type="text"
                                            onChange={handleChange}
                                            value={editData.advPaymentReferenceNo}
                                        />
                                    </Grid>
                                </>
                                :
                                <>
                                    <Grid item xs={2} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Reference No</Typography>
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_input}`}>
                                        <div className={`${styles.skeleton_text}`}>
                                            <Typography style={{ fontSize: '12px', padding: '1px 4px 1px 10px', color: '#707070' }}> </Typography>
                                        </div>
                                    </Grid>
                                </>
                            }
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Advance Date</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        name="advanceDate"
                                        inputFormat="DD/MM/YYYY"
                                        value={advanceDate}
                                        onChange={handleChangeAdvancDate}
                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                            fullWidth />}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>{location.pathname == '/sales/add-advance-customer-payment' ? 'Customer Name' : 'Supplier Name'}</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <Autocomplete
                                    fullWidth
                                    classes={{
                                        option: classes.option,
                                    }}
                                    noOptionsText={
                                        <span className={classes.noOptionsLabel}>No options</span>
                                    }
                                    options={CNS_list}
                                    value={CNS_id}
                                    onChange={handleChangeCNS}
                                    getOptionLabel={(option) => option.CNS_Name}
                                    getOptionSelected={(option, value) => option.id === value.CSNId}
                                    renderInput={(params) => <ERPinput required
                                        placeholder={location.pathname == '/sales/add-advance-customer-payment' ? "Please Select  Customer" : "Please Select  Supplier"}
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: 25,
                                                fontSize: 12,
                                            }
                                        }} {...params} />}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Amount</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    required
                                    size='small'
                                    fullWidth
                                    name="amount"
                                    type="number"
                                    onChange={handleChange}
                                    value={data.amount}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Payment Mode</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    fullWidth
                                    select
                                    required
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="paymentMode"
                                    value={(data.paymentMode)}
                                    size='small'
                                    onChange={(e) => handleChange(e)}
                                >
                                    <MenuItem value="Cash" className={`${styles.erp_lable}`}>Cash</MenuItem>
                                    <MenuItem value="Bank" className={`${styles.erp_lable}`}>Bank</MenuItem>
                                    <MenuItem value="NEFT" className={`${styles.erp_lable}`}>NEFT</MenuItem>
                                    <MenuItem value="IMPS" className={`${styles.erp_lable}`}>IMPS</MenuItem>
                                    <MenuItem value="RTGS" className={`${styles.erp_lable}`}>RTGS</MenuItem>
                                    <MenuItem value="Cheque" className={`${styles.erp_lable}`}>Cheque</MenuItem>
                                </ERPinput>
                            </Grid>
                            {data.paymentMode !== 'Cash' &&
                                <>
                                    <Grid item xs={2} className={`${styles.grid_lable}`}>
                                        <Typography className={`${styles.erp_lable}`}>Payment Through</Typography>
                                    </Grid>
                                    <Grid item xs={4} className={`${styles.grid_input}`}>
                                        <Autocomplete
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={bankList}
                                            value={bank_id}
                                            onChange={handleChangeBank}
                                            getOptionLabel={(option) => option.bankName + ' (' + option.branchCode + ')'}
                                            getOptionSelected={(option, value) => option.id === value.bank_id}
                                            renderInput={(params) => <ERPinput
                                                placeholder="Please Select Bank Name"
                                                sx={{
                                                    "& .MuiInputBase-root": {
                                                        height: 25,
                                                        fontSize: 12,
                                                    }
                                                }} {...params} />}
                                        />

                                    </Grid>
                                </>
                            }
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Instrument/UTR No</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="instrumentNo"
                                    value={data.instrumentNo}
                                />
                            </Grid>

                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Remark</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    name="remark"
                                    type="text"
                                    onChange={handleChange}
                                    value={(data.remark)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Box sx={{ marginTop: '12px', float: 'right', }}>
                        <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                            <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                        </Button>
                        <Cancel />
                    </Box>
                    </form>
                </Paper>
                {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage}
                    autoHideDuration={2000}
                    message={successMessage}
                />
            }
            </div>
        </>
    )
}

export default Customer_Supplier_AdvancePaymentAdd